<template>
  <el-dialog
    title="Edit Owner"
    :visible.sync="dialogVisible"
    width="50%"
    @close="closeDialog"
  >
    <el-table v-if="rolesData" class="custom-table overflow" :data="rolesData">
      <el-table-column width="70">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.selected"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="Role">
        <template slot-scope="scope">
          <span>{{ scope.row.role }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="Is member">
        <template slot-scope="scope">
          <span>{{ selectedClass.extensions && selectedClass.extensions.includes(scope.row.role) ? "Yes" : "No" }}</span>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">Close</el-button>
      <el-button type="primary" @click="saveMemberRoles" :disabled="savingMemberRoles" :loading="savingMemberRoles">{{ savingMemberRoles ? "Saving" : "Save" }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ClassHead from "../../classroom/google/ClassHead.vue";
import GroupHead from "../../classroom/microsoft/GroupHead.vue";
import gql from "graphql-tag";

const UPDATE_THIRD_PARTY_CLASS = gql`
	mutation UpdateThirdPartyClass($classId: String!, $properties: ClassProperties!) {
		UpdateThirdPartyClass(data: { classId: $classId, properties: $properties }) {
			id
			ownerId
		}
	}
`;

export default {
  props: {
    isDialogVisible: {
      type: Boolean,
      required: true
    },
    members: {
      type: Array,
      required: false
    },
    selectedClass: {
      type: Object,
      required: true
    },
    userRoles: {
      type: Array,
      required: true
    }
  },
  components: {
    ClassHead,
    GroupHead
  },
  data() {
    return {
      dialogVisible: this.isDialogVisible,
      loading: false,
      thirdPartyClassOwner: null,
      savingMemberRoles: false,
      rolesData: JSON.parse(JSON.stringify(_.map(this.userRoles, (role) => {
        role.selected = this.selectedClass.extensions && this.selectedClass.extensions.includes(role.role);
        return role;
      })))
    };
  },
  watch: {
    isDialogVisible(newVal) {
      this.dialogVisible = newVal;

      if (newVal === true) {
        this.savingMemberRoles = false;
      }
    },
  },
  computed: {
		owner() {
      return _(this.membersFiltered)
        .filter((member) => {
          return (!_.isEmpty(this.thirdPartyClassOwner) && this.thirdPartyClassOwner.split(",").includes(member.id));
        })
        .map((member) => member.name)
        .value();
		},
    ownerIds() {
      return _(this.members)
        .filter((member) => {
          return (!_.isEmpty(this.thirdPartyClassOwner) && this.thirdPartyClassOwner.split(",").includes(member.id));
        })
        .map((member) => member.id)
        .value()
    },
    rolesInput(){
      return _(this.rolesData)
        .filter((role) => {
          return role.selected;
        })
        .map("role")
        .value();
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close-members-dialog");
      this.dialogVisible = false;
    },
    setOwner(id) {
			this.loading = true;
			this.$apollo
				.mutate({
					mutation: UPDATE_THIRD_PARTY_CLASS,
					variables: {
						classId: this.selectedClass.id,
						properties: {
							ownerId: id,
						}
					},
				})
				.then((r) => {
					this.loading = false;
					this.$message.success("Owner updated");
				})
				.catch((e) => {
					this.loading = false;
					this.$message.error("Failed to update class ownership");
				});
		},
		removeOwner(id) {
			this.loading = true;
			this.$apollo
				.mutate({
					mutation: UPDATE_THIRD_PARTY_CLASS,
					variables: {
						classId: this.selectedClass.id,
						properties: {
							removeOwnerId: id,
						}
					},
				})
				.then((r) => {
					this.loading = false;
					this.$message.success("Owner updated");
				})
				.catch((e) => {
					this.loading = false;
					this.$message.error("Failed to update class ownership");
				});
		},
    async saveMemberRoles() {
      this.savingMemberRoles = true;

      await this.$apollo.mutate({
          mutation: gql`
            mutation ClassMembersRole($input: ClassMembersRoleInput!){
              ClassMembersRole(input: $input)
            }`,
            variables: {
              input: {
                providerId: this.selectedClass.id,
                roles: this.rolesInput,
              }
            }
        });

      this.savingMemberRoles = false;
      this.closeDialog();
    },
  },
  apollo: {
		thirdPartyClassOwner: {
			query: gql`
				query ThirdPartyClass($classId: String!, $members: [String!]!) {
					ThirdPartyClass(classId: $classId, members: $members) {
						id
						ownerId
					}
				}
			`,
			variables() {
				return {
					classId: this.selectedClass.id,
					members: [],
				}
			},
			fetchPolicy: "no-cache",
			update(r) {
				return r.ThirdPartyClass.ownerId;
			}
		},
	}
};
</script>
